const AS_LAST_USER_LOGGED = '@painel-linvix-sistemas/last_user_logged';
const AS_USER_TOKEN = '@painel-linvix-sistemas/user_token';
const AS_USER_DATA = '@painel-linvix-sistemas/user_data';

export default {
    AS_LAST_USER_LOGGED,
    AS_USER_TOKEN,
    AS_USER_DATA
}